import { StringSearchFilterType } from '@warebee/frontend/data-access-api-graphql';
import { t } from 'i18next';
import _ from 'lodash';
import { getItemSetMetricDescriptors } from '../itemSet/itemSetMetric.default';
import { getItemStatsMetricDescriptors } from '../itemStats/itemStatsMetric.default';
import { getLocationMetricDescriptors } from '../location/locationMetric.default';
import {
  ActualityMetric,
  ActualityMetricDescriptorBase,
} from './actualityMetric.types';

export const actualityMetricDescriptors: ActualityMetricDescriptorBase[] = [
  ...(getItemSetMetricDescriptors(t) as any),
  ...(getItemStatsMetricDescriptors(t) as any),
  // ...assignmentMetricDescriptors,
  ...(getLocationMetricDescriptors(t) as any),

  {
    type: 'lastActivity',
    path: 'eventEndTimeMs',
    rangeType: 'distinct-range',
    sequentialPaletteId: 'velocity-analytics',
    aggregationFn: 'max',
    // description:
  },
  {
    type: 'processTypeLatest',
    path: 'eventProcessType',
    rangeType: 'distinct',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'last',
  },
  {
    type: 'processType',
    path: 'eventProcessType',
    rangeType: 'distinct',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'distinct',
  },
  {
    type: 'jobGroup',
    path: 'jobGroupId',
    rangeType: 'distinct',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'distinct',
  },
  {
    type: 'visits',
    path: 'locationId',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'count',
  },
  {
    type: 'distance',
    path: 'distance',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'sum',
  },
  {
    type: 'distanceAverage',
    path: 'distance',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'avg',
  },
  {
    type: 'visitsReplenishment',
    path: 'assignmentItem',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'count',
    filterBy: {
      eventProcessType: {
        type: StringSearchFilterType.CONTAINS,
        value: 'REPLENISHMENT',
      },
    },
  },
  {
    type: 'avgReplenishmentDistance',
    path: 'distanceTravellingInternal',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'avg',
    filterBy: {
      eventProcessType: {
        type: StringSearchFilterType.CONTAINS,
        value: 'REPLISHMENT',
      },
    },
  },
  {
    type: 'totalUomQty',
    path: 'quantity',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'sum',
  },
  {
    type: 'avgUomQty',
    path: 'quantity',
    rangeType: 'range-pow',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'avg',
  },

  {
    type: 'sequenceValidation',
    path: 'hasIssueWithProductSequence',
    rangeType: 'range-linear',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'sum',
  },
  {
    type: 'productLocationValidation',
    path: 'hasIssueWithLocationPerProduct',
    rangeType: 'range-linear',
    sequentialPaletteId: 'heatmap-analytics',
    aggregationFn: 'sum',
  },
  {
    type: 'pickByAssignment',
    path: 'pickByAssignment',
    rangeType: 'distinct',
    aggregationFn: 'min',
    qualitativePaletteId: 'booleanCompliance',
  },
];

export const actualityMetricDescriptorsMap = _.keyBy(
  actualityMetricDescriptors,
  d => d.type,
) as Record<ActualityMetric, ActualityMetricDescriptorBase>;
